import { z } from 'zod';

// Status config maps a "from" itinerary status UUID to a "to" status —
// the collection's templated tasks fire when an itinerary transitions
// between these. Verbatim from legacy
// travel_planner_back/src/task/dto/create-task-collection.dto.ts.
export const taskCollectionStatusConfigSchema = z.object({
  from: z.uuid(),
  to: z.uuid(),
});
export type TaskCollectionStatusConfig = z.infer<
  typeof taskCollectionStatusConfigSchema
>;

export const taskCollectionSchema = z.object({
  id: z.uuid(),
  organizationId: z.uuid(),
  title: z.string(),
  type: z.string(),
  order: z.number().int(),
  createdOn: z.string(),
  modifiedOn: z.string().nullable(),
  statusConfig: taskCollectionStatusConfigSchema.nullable(),
});
export type TaskCollection = z.infer<typeof taskCollectionSchema>;

// List rows carry the count of template tasks in the collection so the
// Collections tab can show "N Tasks" without fetching each row's tasks.
export const taskCollectionListItemSchema = taskCollectionSchema.extend({
  taskCount: z.number().int().nonnegative(),
});
export type TaskCollectionListItem = z.infer<
  typeof taskCollectionListItemSchema
>;

export const createTaskCollectionInput = z.object({
  title: z.string().min(1),
  type: z.string().min(1),
  order: z.number().int(),
  statusConfig: taskCollectionStatusConfigSchema.optional(),
});
export type CreateTaskCollectionInput = z.infer<
  typeof createTaskCollectionInput
>;

export const updateTaskCollectionInput = createTaskCollectionInput
  .partial()
  .extend({
    id: z.uuid(),
  });
export type UpdateTaskCollectionInput = z.infer<
  typeof updateTaskCollectionInput
>;

export const findTaskCollectionsInput = z.object({
  offset: z.number().int().nonnegative().default(0),
  limit: z.number().int().positive().max(100).default(50),
  title: z.string().optional(),
});
export type FindTaskCollectionsInput = z.infer<typeof findTaskCollectionsInput>;

export const searchTaskCollectionByTitleInput = z.object({
  title: z.string().min(1),
});
export type SearchTaskCollectionByTitleInput = z.infer<
  typeof searchTaskCollectionByTitleInput
>;

export const availableTaskCollectionsForItineraryInput = z.object({
  itineraryId: z.uuid(),
});
export type AvailableTaskCollectionsForItineraryInput = z.infer<
  typeof availableTaskCollectionsForItineraryInput
>;

export const paginatedTaskCollectionsSchema = z.object({
  data: z.array(taskCollectionListItemSchema),
  total: z.number(),
  offset: z.number(),
  limit: z.number(),
});
export type PaginatedTaskCollections = z.infer<
  typeof paginatedTaskCollectionsSchema
>;
